export const VIDEO_SOURCE_MAX_BYTES=50*1024*1024;
export type VideoSourceUpload={filename:string;blob:Blob};
export function readVideoSourceUpload(value:unknown):VideoSourceUpload{
  if(!value||typeof value!=='object'||Array.isArray(value))throw new Error('이미지 파일 하나를 선택해 주세요.');
  const input=value as Record<string,unknown>;
  if(Object.keys(input).some(key=>key!=='filename'&&key!=='blob')||typeof input.filename!=='string'||!input.filename.trim()||input.filename.length>512
    ||!(input.blob instanceof Blob)||!['image/png','image/jpeg','image/webp'].includes(input.blob.type)||input.blob.size<1||input.blob.size>VIDEO_SOURCE_MAX_BYTES)
    throw new Error('50MB 이하 PNG, JPEG, WebP 이미지 하나를 선택해 주세요.');
  return {filename:input.filename,blob:input.blob};
}
export async function verifyVideoSourceUpload(value:unknown):Promise<VideoSourceUpload>{
  const input=readVideoSourceUpload(value),bytes=new Uint8Array(await input.blob.slice(0,12).arrayBuffer());
  const prefix=(values:number[])=>values.every((byte,i)=>bytes[i]===byte);
  const valid=input.blob.type==='image/png'?prefix([137,80,78,71,13,10,26,10]):input.blob.type==='image/jpeg'?prefix([255,216,255]):
    prefix([82,73,70,70])&&[87,69,66,80].every((byte,i)=>bytes[i+8]===byte);
  if(!valid)throw new Error('파일 내용이 이미지 형식과 다릅니다. 원본 이미지를 다시 선택해 주세요.');
  return input;
}
